var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kbo-team-list',{attrs:{"team-code":_vm.teamCode,"change-fn":_vm.changeFn}}),_c('highlight-list',{attrs:{"current-date":_vm.currentDate,"team-code":_vm.teamCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }